import { useEffect, useState } from 'react';
import logoMark from '../../Images/logo/logo.png';

/** Photo when `src` loads; circular B4 mark if missing or broken. */
export default function FallbackImage({ src, alt = '', className }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const useLogo = !src || failed;

  return (
    <img
      className={className}
      src={useLogo ? logoMark : src}
      alt={alt}
      data-fallback={useLogo ? 'true' : undefined}
      onError={() => {
        if (!useLogo) setFailed(true);
      }}
    />
  );
}
